<template>
    <div v-if="isVisible" class="dialog-overlay">
        <div class="dialog-box">
            <div class="dialog-content">
                <h2 class="dialog-title">{{ displayTitle }}</h2>
                <input
                    class="dialog-input"
                    type="text"
                    :value="displayText"
                    readonly
                />
                <p class="dialog-warning">{{ $t('lang.addressWarning') }}</p>
                <button
                    class="dialog-confirm"
                    :disabled="isDisabled"
                    @click="onConfirm"
                >
                    {{ $t('lang.Confirm') }}
                    <span v-if="isDisabled"> ({{ countdown }})</span>
                </button>
                <div v-if="message" class="dialog-message">{{ message }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false,
            displayText: '',     // 用于显示的文本
            displayTitle: '', // 弹窗标题
            isDisabled: true,
            countdown: 3,
            timer: null,
            message: ''
        };
    },
    methods: {
        // 打开弹窗并传入要显示的文本
        openDialog(text, title) {
            this.displayText = text;
            this.displayTitle = title;
            this.isVisible = true;
            this.isDisabled = true;
            this.countdown = 3;
            this.message = '';
            this.startCountdown();
        },
        startCountdown() {
            if (this.timer) clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (this.countdown > 1) {
                    this.countdown--;
                } else {
                    this.isDisabled = false;
                    clearInterval(this.timer);
                    this.timer = null;
                    this.countdown = 0;
                }
            }, 1000);
        },
        onConfirm() {
            this.closeDialog();
        },
        closeDialog() {
            this.isVisible = false;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.$emit('close');
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
};
</script>

<style lang="less" scoped>
.dialog-overlay {
    position: fixed;
    z-index: 2000;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(44, 45, 49, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
}

.dialog-box {
    background: #fff;
    border-radius: 8px;
    min-width: 320px;
    max-width: 400px;
    width: 90vw;
    box-shadow: 0 8px 32px rgba(44, 45, 49, 0.15);
    padding: 28px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dialog-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dialog-title {
    font-size: 20px;
    font-weight: 600;
    color: #222;
    margin-bottom: 18px;
    letter-spacing: 0.5px;
    text-align: center;
}

.dialog-input {
    width: 100%;
    max-width: 360px;
    padding: 10px 14px;
    font-size: 14px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    background: #f4f5f6;
    color: #333;
    margin-bottom: 20px;
    outline: none;
    word-break: break-all;
}

.dialog-input:focus {
    border-color: #4458fe;
    background: #e7eafe;
}

.dialog-warning {
    font-size: 13px;
    color: #ff8800;
    background: #fff7e6;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 16px;
    line-height: 1.7;
    text-align: justify;
    max-width: 360px;
    word-break: break-all;
}

.dialog-confirm {
    width: 180px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: #4458fe;
    border: none;
    border-radius: 4px;
    transition: background 0.2s;
    cursor: pointer;
    margin-bottom: 12px;
}

.dialog-confirm[disabled] {
    background: #e6e6e6;
    color: #999;
    cursor: not-allowed;
}

.dialog-message {
    color: #4458fe;
    font-size: 15px;
    margin-top: 10px;
    font-weight: 700;
}
</style>
